import { queryOptions } from "@tanstack/react-query";
import { apiClient } from "../../../zodios/client";

export const useAdHistoryEntityTypes = () =>
  queryOptions({
    queryKey: [{ entity: "adHistoryEntityTypes" }],
    queryFn: async () => await apiClient.getAdHistoryEntityTypes(),
    staleTime: Infinity,
    gcTime: Infinity,
  });
